module.exports = __webpack_public_path__ + "img/mother.200f487f.jpg";